/**
 * The form completion by type widget and forms completed widget make use of
 * different date parameters. While we could've added explicit search params
 * for the drilldown route instead of relying on the generic from/to, we
 * would've had to account for such scenario in the base search params
 * inheriting from the parent route, so instead we do a simple map based on
 * which widget opened the drilldown.
 */
export function getMappedDateParams(
  source?: 'form-completion-by-type' | 'forms-completed'
) {
  if (source === 'form-completion-by-type' || source === 'forms-completed') {
    return { from: 'minCompletedDate', to: 'maxCompletedDate' } as const;
  }
  return { from: 'minCreated', to: 'maxCreated' } as const;
}
